<template>
  <div>
    <!-- <b-overlay :show="is_all_report_list_loaded" no-wrap></b-overlay> -->
    <template v-if="current_report_code || (selected_report && not_found === '')">
      <ViewAssuranceStatement v-if="['/a'].includes($route.path)" />
      <FullView2021 v-else-if="$route.path === '/v' || getParsedReportCodeFromUrl" />
      <GRITableView2021 v-else-if="['/g', '/s', '/t'].includes($route.path)" />
    </template>
    <template v-else-if="not_found != ''">
      <div class="vh-100 text-center bgray-200">
        <div style="height: 70vh" class="d-flex justify-content-center align-items-center">
          <h2 class="teal8 pt-5 pb-2 border-bottom-teal7 px-md-5">
            <span v-if="not_found == 'not_published'">아직 공개되지 않은 보고서 입니다.</span>
            <span v-else-if="not_found == 'not_exitst'">존재하지 않는 보고서 입니다.</span>
            <span v-else> 알 수 없는 에러입니다. 시스템 관리자에 문의해 주세요.</span>
          </h2>
        </div>

        <div>
          <b-button variant="icon-teal" href="https://report.qesg.co.kr"
            >ESG Reporting Tool 바로가기 <b-icon icon="link-45deg" class="mr-1" />
          </b-button>
          <b-button
            variant="icon-teal"
            href="https://qesg.co.kr"
            target="_blank"
            class="m-0 mx-sm-3"
            >QESG 바로가기 <b-icon icon="link-45deg" class="mr-1"
          /></b-button>
          <b-button variant="icon-teal" href="https://qesg.co.kr/#i-5" target="_blank"
            >문의하기
            <fa icon="question-circle" class="ml-1" />
          </b-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import { read_mixin } from '@/mixins/read_mixin';
import FullView2021 from '@/components/report_preview/gri2021_viewer/FullView2021.vue';
import GRITableView2021 from '@/components/report_preview/gri2021_viewer/GRITableView2021.vue';
import ViewAssuranceStatement from '@/components/report_preview/appendix_subs/ViewAssuranceStatement';

export default {
  name: 'ViewerMaster',
  components: {
    FullView2021,
    GRITableView2021,
    ViewAssuranceStatement
  },
  mixins: [read_mixin],
  data() {
    return {
      not_found: '',
      loadingShow: true,
      originalFontSize: ''
    };
  },
  computed: {
    ...mapGetters(['is_viewer']),
    ...mapGetters('report_list', ['selected_report', 'current_report_code']),
    ...mapState('report_list', ['is_all_report_list_loaded', 'viewer_report_code', 'view_mode']),
    ...mapState('story_board', ['is_fetching_lv2_disclosure']),
    ...mapGetters('story_board', [
      'sb_toc',
      'selected_lv1',
      'selected_lv2',
      'selected_viewer_disclosures'
    ]),
    ...mapGetters('assurance', ['has_assurance_content', 'is_assurance_deployed']),
    getParsedReportCodeFromUrl() {
      if (process.env.VUE_APP_REPORT_CODE) {
        return process.env.VUE_APP_REPORT_CODE;
      } else {
        const queryReportCode = this.$route.query.r;
        return queryReportCode ? queryReportCode.split('?')[0] : '';
      }
    }
  },
  methods: {
    ...mapActions('story_board', [
      'fetch_sb_toc',
      'fetch_main_setting_from_viewer',
      'fetch_viewer_sb_disclosures'
    ]),
    ...mapMutations('story_board', ['update_selected_lv1', 'update_selected_lv2']),
    ...mapMutations('report_list', [
      'update_viewer_report_code',
      'update_all_report_list_loaded',
      'update_view_mode',
      'change_lang'
    ]),
    decodeKey(key) {
      return key
        .replace(/%20/g, ' ')
        .replace(/%0A/g, '\n')
        .replace('+', ' ')
        .replace('\n', '')
        .trim();
    },

    handleRouteChange(to) {
      try {
        const { lv1: lv1Key, lv2: lv2Key, l: lang } = to.query;
        if (lang) {
          if (lang === 'ENG') {
            this.change_lang('ENG');
          } else {
            this.change_lang('KOR');
          }
        } else {
          this.change_lang('KOR');
        }

        if (!this.sb_toc || this.sb_toc.length === 0) return;

        const decodeKey = this.decodeKey;

        if (lv1Key) {
          const lv1_info = this.sb_toc.find(
            item =>
              decodeKey(item.name) === lv1Key.trim().replace('\n', '') || item.key === lv1Key.trim()
          );

          if (lv1_info) {
            if (lv1_info.key !== this.selected_lv1?.key) {
              this.update_selected_lv1({
                lv1_info,
                view_mode: this.is_viewer ? 'viewer' : 'editor'
              });
            }

            if (lv2Key) {
              const lv2_info = lv1_info.children?.find(
                item =>
                  decodeKey(item.name) === lv2Key.trim().replace('\n', '') ||
                  item.key === lv2Key.trim()
              );

              if (lv2_info && lv2_info.key !== this.selected_lv2?.key) {
                this.update_selected_lv2({
                  lv2_info,
                  view_mode: this.is_viewer ? 'viewer' : 'editor'
                });
              }

              if (!this.is_fetching_lv2_disclosure && !this.selected_viewer_disclosures) {
                this.fetch_viewer_sb_disclosures({
                  report_code: this.current_report_code,
                  selected_lv_info: {
                    lv1_info,
                    lv2_info
                  }
                });
              }
            }
          }
        } else {
          this.update_selected_lv1({
            lv1_info: null,
            view_mode: this.is_viewer ? 'viewer' : 'editor'
          });
          this.update_selected_lv2({
            lv2_info: null,
            view_mode: this.is_viewer ? 'viewer' : 'editor'
          });
        }
      } catch (error) {
        console.error('[handleRouteChange error]', error);
      }
    },

    async handleReportStatus(parsed_report_code) {
      await this.readAll(parsed_report_code);
      this.readAssurance(parsed_report_code);

      this.$nextTick(() => {
        if (parsed_report_code && this.is_all_report_list_loaded) {
          if (this.selected_report) {
            if (this.selected_report.state === 4) {
              // this.update_viewer_report_code(this.selected_report.report_code);
            } else {
              this.not_found = 'not_published';
              console.warn('아직 공개되지 않은 보고서 입니다.');
            }
          } else {
            this.not_found = 'not_exitst';
            console.warn('존재하지 않는 보고서 입니다.');
          }
        } else {
          this.not_found = 'donno';
        }
      });
    },

    async setupViewerMode() {
      const parsed_report_code = this.getParsedReportCodeFromUrl;
      if (parsed_report_code) {
        await this.handleReportStatus(parsed_report_code);
      }

      // if (this.$route.query.l === 'ENG') {
      //   this.change_lang('ENG');
      // }
    }
  },
  watch: {
    sb_toc: {
      immediate: true,
      handler() {
        this.handleRouteChange(this.$route);
      }
    },
    $route: {
      immediate: true,
      handler(to, from) {
        this.handleRouteChange(to);
      }
    },
    selected_report(newVal) {
      if (this.current_report_code && newVal.report_code === this.current_report_code) {
        document.documentElement.style.setProperty('--main-color', newVal.main_color);

        this.originalFontSize =
          document.documentElement.style.fontSize ||
          window.getComputedStyle(document.documentElement).fontSize;

        if (newVal.font_size) {
          document.documentElement.style.fontSize = `${newVal.font_size}px`;
        }
      }
    }
  },
  async mounted() {
    this.update_view_mode('viewer');

    if (this.is_viewer) {
      this.setupViewerMode();
    } else {
      this.update_view_mode('editor');
    }
  },
  beforeDestroy() {
    document.documentElement.style.fontSize = this.originalFontSize;
  }
};
</script>
<style></style>
